import request from "@/utils/request";

export function getCaptcha() {
  return request({ url: "/captchaImage", method: "get" });
}

export function login(data) {
  return request({ url: "/login", method: "post", data });
}

export function getInfo() {
  return request({ url: "/getInfo", method: "get" });
}

export function logout() {
  return request({ url: "/logout", method: "post" });
}

/** 当前登录用户修改密码（RSA 密文，各角色通用） */
export function changePassword(data) {
  return request({ url: "/profile/password", method: "put", data });
}

export function dashboardStat() {
  return request({ url: "/monitor/dashboard", method: "get" });
}

/** 后台首页看板（数据概览、本学期、我的班级等） */
export function dashboardHome() {
  return request({ url: "/monitor/dashboard/home", method: "get" });
}

/** 管理端数据大屏（教学资源中心态势） */
export function situationScreen() {
  return request({ url: "/monitor/situation", method: "get" });
}
